import API from '../functions/api';

const UPDATE_ALL = "MODELS/UPDATE_ALL";
const SET_SELECTED_MODEL = "MODELS/SET_SELECTED_MODEL";
const SET_RYI_VARIANTS = "MODELS/SET_RYI_VARIANTS";
const SET_IS_FETCHING_MODELS = "MODELS/SET_IS_FETCHING_MODELS";

export function fetchModels(type, cb, errCb) {
    return (dispatch, getState) => {
        // If we already have the data, resolve this promise immediately.
        const { models } = getState();
        if (models[type]) {
            return Promise.resolve();
        }

        dispatch({type: SET_IS_FETCHING_MODELS, payload: true});
        return API.get(
            `1/legacy/GetModelList?type=${type}`
        ).then((response) => {
            dispatch({
                type: UPDATE_ALL,
                payload: {
                    type,
                    models: response.data?.data,
                },
            });
            dispatch({type: SET_IS_FETCHING_MODELS, payload: false});
            if (typeof cb === "function") { cb(); }
        }).catch((error) => {
            // TODO: handle this.
            console.error(error);
            dispatch({type: SET_IS_FETCHING_MODELS, payload: false});
            if (typeof errCb === "function") { errCb(); }
        });
    };
}

export function setSelectedModel(model, variant) {
    return (dispatch) => {
        dispatch({
            type: SET_SELECTED_MODEL,
            payload: {model, variant}
        });
    };
}

export function fetchRYIVariants(urlVariant, variantIds = []) {
    return (dispatch, getState) => {

        var preSelectedString = urlVariant ? urlVariant.replace('é','e').replace(/[^a-z0-9]/gi,'').toLowerCase() : false;
        var gqlFilter = {status: {eq: true}, ryi: {eq: true}};
        if (variantIds?.length > 0) {
            gqlFilter.variantId = { in: variantIds.map(id => parseInt(id, 10)) };
        }
        API.post(`${process.env.RAZZLE_GQLAPI}`, {
            query: /* GraphQL */`query ($skip: Int, $take: Int, $sort: VariantDtoSortInput!, $filter: VariantDtoFilterInput) {
                variantList(skip: $skip, take: $take, order: [ $sort ], where: $filter) {
                    items {
                        variantId
                        name
                        heroImage
                        ryiStatus
                        engineType
                        isEtron: electric
                        modelId
                        activeBrochureName
                    }
                    totalCount
                }
            }`,
            variables: {
                skip: 0,
                take: 50,
                sort: {name: "ASC"},
                filter: gqlFilter
            }
        }).then((result) => {
            if (result.data?.data?.variantList?.items) {
                let list = result.data.data.variantList.items;
                let preSelectedVariant = null;
                for (let i=0; i<list.length; i++) {
                    let item = list[i];
                    item.slug = item.name.replace('é','e').replace(/[^a-z0-9]/gi,'').toLowerCase();
                    if (item.slug === preSelectedString) {
                        preSelectedVariant = item;
                    }
                    if (!item.engineType) {
                        item.engineType = item.isEtron ? "E" : "G";
                        // TODO: isEtron should be removed once engineType has been set for all variants
                    }
                    list[i] = item;
                }
                dispatch({
                    type: SET_RYI_VARIANTS,
                    payload: list,
                    preSelectedVariant
                });
            }
        }).catch((error) => {
            console.error(error);
        });

    };
}

export function modelsReducer(state = {}, action) {
    switch (action.type) {
    case UPDATE_ALL:
        return Object.assign({}, state, {
            [action.payload.type]: action.payload.models
        });
    case SET_SELECTED_MODEL:
        return Object.assign({}, state, {
            selectedModelId: action.payload.model,
            selectedVariantId: action.payload.variant,
        });
    case SET_RYI_VARIANTS:
        return Object.assign({}, state, {
            ryiVariants: action.payload,
            ryiPreSelectedVariant: action.preSelectedVariant
            // ryiPreSelectedIndex: action.idx,
            // ryiMetaTitle: action.title,
            // ryiMetaDescription: action.description
        });
    case SET_IS_FETCHING_MODELS:
        return Object.assign({}, state, {
            isFetchingModels: action.payload
        });
    default:
        return state;
    }
}
